import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { class: "input-upload-wrapper" }
const _hoisted_4 = { class: "input-upload-wrapper" }
const _hoisted_5 = { class: "input-upload-wrapper" }
const _hoisted_6 = { class: "submit-button-wrapper" }

import { onMounted, reactive } from "vue";
import { ConfigService } from "@/api/services/ConfigService";
import { WxPay } from "@/api/models/config/WxPay";
import { message } from "ant-design-vue";
import { WxPayRequest } from "@/api/models/config/WxPayRequest";
import FileUpload from "@/components/FileUpload.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'PayView',
  setup(__props) {

const wxPay = reactive<WxPay>({});

const handleWxPay = async () => {
  const res = await ConfigService.WxPayGet();
  if (res.code === 0) {
    Object.assign(wxPay, res.data);
  } else {
    message.error(res.msg);
  }
};

const submitWxPay = async () => {
  const r: WxPayRequest = {};
  Object.assign(r, wxPay);
  const res = await ConfigService.WxPay(r);
  if (res.code === 0) {
    message.success("微信支付配置修改成功");
    setTimeout(() => location.reload(), 1000);
  } else {
    message.error(res.msg);
  }
};

onMounted(async () => {
  await handleWxPay();
});

return (_ctx: any,_cache: any) => {
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_a_button = _resolveComponent("a-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[13] || (_cache[13] = _createElementVNode("h2", { class: "payment-title" }, "微信支付配置", -1)),
      _createVNode(_component_a_form, {
        model: wxPay,
        class: "payment-form",
        "label-col": { style: { width: '120px' } }
      }, {
        default: _withCtx(() => [
          _createVNode(_component_a_form_item, { label: "AppId" }, {
            default: _withCtx(() => [
              _createVNode(_component_a_input, {
                value: wxPay.wx_pay_app_id,
                "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((wxPay.wx_pay_app_id) = $event)),
                placeholder: "请输入微信支付AppId",
                class: "payment-input"
              }, null, 8, ["value"])
            ]),
            _: 1
          }),
          _createVNode(_component_a_form_item, { label: "支付商户号" }, {
            default: _withCtx(() => [
              _createVNode(_component_a_input, {
                value: wxPay.wx_pay_merchant_id,
                "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((wxPay.wx_pay_merchant_id) = $event)),
                placeholder: "请输入支付商户号",
                class: "payment-input"
              }, null, 8, ["value"])
            ]),
            _: 1
          }),
          _createVNode(_component_a_form_item, { label: "证书序列号" }, {
            default: _withCtx(() => [
              _createVNode(_component_a_input, {
                value: wxPay.wx_pay_serial_no,
                "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((wxPay.wx_pay_serial_no) = $event)),
                placeholder: "请输入证书序列号",
                class: "payment-input"
              }, null, 8, ["value"])
            ]),
            _: 1
          }),
          _createVNode(_component_a_form_item, { label: "微信支付公钥Id" }, {
            default: _withCtx(() => [
              _createVNode(_component_a_input, {
                value: wxPay.wx_pay_public_content_id,
                "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((wxPay.wx_pay_public_content_id) = $event)),
                placeholder: "请输入微信支付公钥Id",
                class: "payment-input"
              }, null, 8, ["value"])
            ]),
            _: 1
          }),
          _createVNode(_component_a_form_item, { label: "支付密钥" }, {
            default: _withCtx(() => [
              _createVNode(_component_a_input, {
                value: wxPay.wx_pay_key,
                "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((wxPay.wx_pay_key) = $event)),
                placeholder: "请输入支付密钥",
                class: "payment-input"
              }, null, 8, ["value"])
            ]),
            _: 1
          }),
          _createVNode(_component_a_form_item, { label: "支付回调地址" }, {
            default: _withCtx(() => [
              _createVNode(_component_a_input, {
                value: wxPay.wx_pay_notify_url,
                "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => ((wxPay.wx_pay_notify_url) = $event)),
                placeholder: "请输入支付回调地址",
                class: "payment-input"
              }, null, 8, ["value"])
            ]),
            _: 1
          }),
          _createVNode(_component_a_form_item, { label: "公钥证书" }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_3, [
                _createVNode(_component_a_input, {
                  value: wxPay.wx_pay_public_key,
                  "onUpdate:value": _cache[6] || (_cache[6] = ($event: any) => ((wxPay.wx_pay_public_key) = $event)),
                  placeholder: "请输入公钥证书",
                  class: "custom-input"
                }, null, 8, ["value"]),
                _createVNode(FileUpload, {
                  modelValue: wxPay.wx_pay_public_key,
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((wxPay.wx_pay_public_key) = $event))
                }, null, 8, ["modelValue"])
              ])
            ]),
            _: 1
          }),
          _createVNode(_component_a_form_item, { label: "私钥证书" }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_4, [
                _createVNode(_component_a_input, {
                  value: wxPay.wx_pay_private_key,
                  "onUpdate:value": _cache[8] || (_cache[8] = ($event: any) => ((wxPay.wx_pay_private_key) = $event)),
                  placeholder: "请输入私钥证书",
                  class: "custom-input"
                }, null, 8, ["value"]),
                _createVNode(FileUpload, {
                  modelValue: wxPay.wx_pay_private_key,
                  "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((wxPay.wx_pay_private_key) = $event))
                }, null, 8, ["modelValue"])
              ])
            ]),
            _: 1
          }),
          _createVNode(_component_a_form_item, { label: "微信支付公钥证书" }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_5, [
                _createVNode(_component_a_input, {
                  value: wxPay.wx_pay_public_content,
                  "onUpdate:value": _cache[10] || (_cache[10] = ($event: any) => ((wxPay.wx_pay_public_content) = $event)),
                  placeholder: "请输入私钥证书",
                  class: "custom-input"
                }, null, 8, ["value"]),
                _createVNode(FileUpload, {
                  modelValue: wxPay.wx_pay_public_content,
                  "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((wxPay.wx_pay_public_content) = $event))
                }, null, 8, ["modelValue"])
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["model"]),
      _createElementVNode("div", _hoisted_6, [
        _createVNode(_component_a_button, {
          type: "primary",
          onClick: submitWxPay,
          class: "submit-button"
        }, {
          default: _withCtx(() => _cache[12] || (_cache[12] = [
            _createTextVNode("提交修改 ")
          ])),
          _: 1
        })
      ])
    ])
  ]))
}
}

})